var SCM = SCM || {};
// A relocated description keeps its XML id, the id a PowerPoint slide note links to. The browser resolves that
// fragment before the relocation and then finds it inside a collapsed panel, so bring the reader to the toggle.
SCM.ImageDescriptionFragment = (function ($) {
    var READER_INPUT_EVENTS = 'wheel touchstart keydown mousedown';
    var SCROLL_TOLERANCE = 4;
    var areHandlersBound = false;
    var scrollPositionSetForFragment = 0;

    return {
        init: init
    };

    function init() {
        if (!SCM.ImageDescriptionToggle || !SCM.ImageDescriptionToggle.hasPanels || !SCM.ImageDescriptionToggle.hasPanels()) {
            return;
        }

        _bindHandlers();
        _goToDescriptionNamedByFragmentWhenLoaded();
    }

    function _bindHandlers() {
        if (areHandlersBound) {
            return;
        }
        areHandlersBound = true;

        $(window).on('hashchange', _goToDescriptionNamedByFragment);
        // Capture phase (jQuery has none): runs before SCM.JumpLinks' body handler, which would animate to the hidden description.
        document.addEventListener('click', _onAnchorClick, true);
    }

    function _onAnchorClick(event) {
        var anchor = $(event.target).closest('a[href^="#"]')[0];
        if (!anchor) {
            return;
        }

        var rid = anchor.getAttribute('href').slice(1);
        var $panel = SCM.ImageDescriptionToggle.findPanelHoldingDescription(rid);
        if (!$panel.length) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        if (window.history && history.replaceState) {
            history.replaceState(null, '', '#' + rid);
        }
        _goToPanel($panel);
    }

    // Until load the browser retries its own jump to the fragment and lands at the top; put the reader back until they touch the page.
    function _goToDescriptionNamedByFragmentWhenLoaded() {
        _goToDescriptionNamedByFragment();

        if (document.readyState === 'complete' || !_panelNamedByFragment().length) {
            return;
        }

        $(document).one(READER_INPUT_EVENTS, _stopHoldingFragmentPosition);
        $(window).on('scroll.imageDescriptionFragment', _returnToFragmentIfDroppedAtTop);
        $(window).one('load', function () {
            _returnToFragmentIfDroppedAtTop();
            _stopHoldingFragmentPosition();
        });
    }

    function _returnToFragmentIfDroppedAtTop() {
        if (window.pageYOffset < SCROLL_TOLERANCE && scrollPositionSetForFragment > SCROLL_TOLERANCE) {
            _goToDescriptionNamedByFragment();
        }
    }

    function _stopHoldingFragmentPosition() {
        $(window).off('scroll.imageDescriptionFragment');
    }

    function _goToDescriptionNamedByFragment() {
        var $panel = _panelNamedByFragment();

        if ($panel.length) {
            _goToPanel($panel);
        }
    }

    function _panelNamedByFragment() {
        return SCM.ImageDescriptionToggle.findPanelHoldingDescription(_fragmentId());
    }

    function _goToPanel($panel) {
        // Centred on the toggle, not the image: a multi-panel figure is taller than the viewport.
        var $toggle = SCM.ImageDescriptionToggle.findToggle($panel);
        var target = $toggle.length ? $toggle[0] : $panel[0];

        _scrollToCentre(target);
        scrollPositionSetForFragment = window.pageYOffset;

        // Keyboard and screen reader users land on the control that reveals the description.
        if ($toggle.length) {
            $toggle[0].focus({ preventScroll: true });
        }
    }

    // A browser without scroll-behavior (IE11) reads the options object as "align to top".
    function _scrollToCentre(element) {
        if ('scrollBehavior' in document.documentElement.style) {
            element.scrollIntoView({ block: 'center', behavior: 'instant' });
        } else {
            element.scrollIntoView(true);
        }
    }

    function _fragmentId() {
        var fragment = window.location.hash.slice(1);
        if (!fragment) {
            return '';
        }

        try {
            return decodeURIComponent(fragment);
        } catch (error) {
            return fragment;
        }
    }
})(jQuery);
